import { localStore } from './storage'

const TOKEN_KEY = 'tx_h5_token'

/** 获取 token */
export function getToken(): string {
  return localStore.get<string>(TOKEN_KEY) || ''
}

/** 设置 token */
export function setToken(token: string): void {
  localStore.set(TOKEN_KEY, token)
}

/** 移除 token */
export function removeToken(): void {
  const router = useRouter()
  localStore.remove(TOKEN_KEY)
  router.replace('/login')
}

/** 是否已登录 */
export function isAuthenticated(): boolean {
  return !!getToken()
}
